import { useState, useRef, useCallback } from 'react';
import { resolveImg } from './ImagePicker';
import { authFetch } from '../auth';

const IMG_API = '/api/images';

export default function ImageDrop({ value, onChange }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [over, setOver] = useState(false);
  const inputRef = useRef();

  const upload = useCallback(async (file) => {
    if (!file || !file.type.startsWith('image/')) { setErr('이미지 파일만 가능합니다.'); return; }
    setBusy(true); setErr('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await authFetch(IMG_API, { method: 'POST', body: fd });
      if (!res.ok) throw new Error(`업로드 실패 (${res.status})`);
      const img = await res.json();
      onChange(img.key);
    } catch (e) {
      setErr(e.message || '업로드 실패');
    } finally {
      setBusy(false);
    }
  }, [onChange]);

  const prevent = (e) => { e.preventDefault(); e.stopPropagation(); };
  const dragHandlers = {
    onDragEnter: (e) => { prevent(e); setOver(true); },
    onDragOver:  (e) => { prevent(e); setOver(true); },
    onDragLeave: (e) => { prevent(e); setOver(false); },
    onDrop:      (e) => { prevent(e); setOver(false); const f = e.dataTransfer.files?.[0]; if (f) upload(f); },
  };

  return (
    <div className="pimg-wrap">
      {value ? (
        <div
          className={`pimg-crop-wrap${over ? ' pimg-drop-active' : ''}`}
          {...dragHandlers}
          onClick={() => inputRef.current?.click()}
          title="클릭하거나 드래그하여 이미지 교체"
        >
          <img src={resolveImg(value)} alt="이미지 미리보기" className="pimg-preview" />
          {over && <div className="pimg-drop-overlay">{busy ? '업로드 중…' : '놓아서 교체'}</div>}
        </div>
      ) : (
        <div
          className={`pimg-zone${over ? ' pimg-zone--over' : ''}${busy ? ' pimg-zone--busy' : ''}`}
          {...dragHandlers}
          onClick={() => !busy && inputRef.current?.click()}
        >
          <div className="pimg-placeholder">
            {busy ? <span>업로드 중…</span> : (
              <>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                </svg>
                <span>이미지를 드래그하거나 클릭하여 업로드</span>
              </>
            )}
          </div>
        </div>
      )}

      {value && (
        <div className="pimg-actions">
          <button type="button" className="btn-pill sm" onClick={() => inputRef.current?.click()} disabled={busy}>
            {busy ? '업로드 중…' : '변경'}
          </button>
          <button type="button" className="btn-pill sm danger" onClick={() => onChange(null)}>
            제거
          </button>
        </div>
      )}
      {err && <p className="pimg-err">{err}</p>}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => { const f = e.target.files?.[0]; if (f) upload(f); e.target.value = ''; }}
      />
    </div>
  );
}
